module.exports = __webpack_public_path__ + "img/David-Salaw.85009860.webp";